<div v-if="options">
	<i18n path="vm.components.popin.refuse-event.text.message" tag="p">
		<strong>{{ $t('vm.components.popin.refuse-event.text.strong') }}</strong>
	</i18n>
	<textarea-frame id="refuse" v-model="options.text"
		:label="$t('vm.components.popin.refuse-event.refuse.label')" 
		:placeholder="$t('vm.components.popin.refuse-event.refuse.placeholder')"/>
</div>
